module.exports = __webpack_public_path__ + "static/media/blog8_sm.70746b01.webp";